<template>
  <div class="ua-size-info">
    <!-- 尺码说明 -->
    <div v-if="cmData.length" class="ua-size-info__item">
      <div v-if="!inlineViewMode" class="ua-size-info__top slidewithcenter">
        <h5 class="ua-size-info__tlt">尺码说明</h5>
      </div>

      <div class="ua-size-tabel__scroll-wrapper">
        <ul class="ua-size-table">
          <li
            v-for="(item, rowIdx) in cmData"
            :key="rowIdx"
            :class="{ 'ua-size-table-row': true, 'is-first-row': rowIdx === 0 }"
          >
            <span
              v-for="(content, key) in item"
              :key="key"
              :style="{
                'flex-basis':
                  key === 0
                    ? '25%'
                    : `${
                        isMobile || isInDrawer
                          ? Math.max(75 / (item.length - 1), 75 / 4)
                          : 75 / (item.length - 1)
                      }%`,
                'flex-grow': item.length > 4 ? 0 : 1
              }"
              :class="{
                'ua-size-table-cell': true,
                'is-first-row': rowIdx === 0,
                'is-odd-row': !(rowIdx % 2)
              }"
              v-html="content"
            ></span>
          </li>
        </ul>
      </div>

      <p class="ua-size-info__tips">
        温馨提醒：
        <br />
        本尺码表仅做参考之用，我们已基于UNDER ARMOUR尺码标准与常用尺码进行转换匹配。
      </p>
    </div>

    <!-- 测量及剪裁说明 -->
    <div v-if="measurement" class="ua-size-info__item">
      <div class="ua-size-info__top slidewithcenter">
        <h5 class="ua-size-info__tlt">测量及剪裁说明</h5>
      </div>
      <div v-if="measurement.picture" style="text-align: center">
        <img
          class="ua-size-info__meas-pic"
          :src="getUrlWithOss(measurement.picture, { bg: 'ffffff' })"
          alt="测量及剪裁说明"
        />
      </div>
      <ul
        v-if="measurement.measuringMethod && measurement.measuringMethod.length"
        class="ua-size-info__attrs"
      >
        <li v-for="item in measurement.measuringMethod" :key="item.methodName">
          <span>{{ item.methodName }}</span>
          <p>{{ item.methodText }}</p>
        </li>
      </ul>
      <div v-if="measurement.style" class="ua-size-info__tooltip">
        <ul class="ua-size-info__tooltip-inner">
          <li
            v-for="item in styles"
            :key="item"
            :class="{ 'is-active': measurement.style === item }"
          >
            <span>{{ item }}</span>
            <span class="icon"></span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 选购与测量贴士 -->
    <!-- <div v-show="false" class="ua-size-info__item">
      <div class="ua-size-info__top slidewithcenter">
        <h5 class="ua-size-info__tlt">选购与测量贴士</h5>
      </div>

      <ul>
        <li></li>
      </ul>
      <p class="ua-size-info__tips">
        温馨提醒：
        <br />
        因为双脚尺寸可能有所不同，建议您左右脚都进行测量并取较大的数值与尺码进行参照。若您的测量数据在两个尺码中间，请您在购买时考虑自己的穿着喜好。针对脚偏宽或脚背偏高者，建议购买大半码。
      </p>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toMap } from '@/utils/pdp';
import ossImage from '@/mixins/ossImage';

export default {
  size: 'SizeInfo',
  mixins: [ossImage],
  props: {
    attributes: {
      type: [Object, Array],
      required: true
    },
    inlineViewMode: {
      type: Boolean,
      default: false
    },
    isInDrawer: Boolean
  },
  data() {
    return {
      cmData: [],
      measurement: null,
      styles: ['强力伸缩型', '修身型', '宽松型']
    };
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  mounted() {
    this.$watch(
      'attributes',
      data => {
        this.transform(Array.isArray(data) ? toMap(data) : data);
      },
      { immediate: true }
    );
  },
  methods: {
    transform(data) {
      const { PDP_CM: { valueCode = '' } = {} } = data || {};
      let jsonData = {};

      try {
        jsonData = JSON.parse(valueCode);
      } catch (e) {
        console.error(e);
      }

      this.jsonData = jsonData;

      if (!this.jsonData.CM) return;

      const { CM: { columns = [], columnsData = [], measurement = {} } = {} } = this.jsonData;

      this.cmData = [columns, ...columnsData];
      this.measurement = measurement;
    }
  }
};
</script>

<style lang="scss" layput="pc" description="网页端样式">
.ua-size-info {
  &__inlineview {
    margin-bottom: 16px;
    padding: 12px 0px;
    border-top: 1px solid var(--line-color-line-grey-02, #eee);
    border-bottom: 1px solid var(--line-color-line-grey-02, #eee);
  }
  &__item {
    margin-bottom: 24px;
  }
  &__top {
    margin-bottom: 16px;
  }
  &__tlt {
    color: var(--main-color-ua-dark-grey, #14141e);

    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }

  &__tips {
    color: var(--secondary-color-ua-cool-grey-03, #8c8c96);

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 175%;
    margin-top: 12px;
  }

  &__attrs {
    > li {
      margin-top: 12px;
    }

    li span {
      color: var(--main-color-ua-dark-grey, #14141e);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      display: block;
    }

    li p {
      margin-top: 2px;
      color: var(--secondary-color-ua-cool-grey-04, #50505a);

      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }
  }

  &__meas-pic {
    width: 192px;
    height: auto;
  }

  &__tooltip {
    margin-top: 12px;
  }

  &__tooltip-inner {
    display: flex;

    li {
      flex-basis: 33.333%;
      flex-grow: 0;
      flex-shrink: 1;
      color: var(--secondary-color-ua-cool-grey-02, #b4b4bf);
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      padding-top: 14px;
      border-top: 1px solid #dddddd;
      position: relative;
    }

    .icon {
      position: absolute;
      top: 0px;
      width: 1px;
      height: 6px;
      background: #dddddd;
    }

    li:nth-of-type(1) {
      .icon {
        left: 0px;
      }
    }

    li:nth-of-type(2) {
      text-align: center;

      .icon {
        left: 50%;
      }
    }
    li:nth-of-type(3) {
      text-align: right;

      .icon {
        right: 0px;
      }
    }

    li.is-active {
      color: var(--main-color-ua-dark-grey, #14141e);
      font-weight: 600;
    }
  }
}
.ua-size-tabel__scroll-wrapper {
  overflow-x: auto;
}
.ua-size-table {
  // min-width: 100%;

  &-row {
    display: flex;

    &:not(.is-first-row) {
      border-left: 1px solid var(--line-color-line-grey-02, #eee);
    }
  }

  &-cell {
    width: 0;
    padding: 14px 0px;
    color: var(--secondary-color-ua-cool-grey-04, #50505a);
    font-size: 14px;
    text-align: center;
    background: #ffffff;
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: content-box;

    border-bottom: 1px solid var(--line-color-line-grey-02, #eee);

    &.is-odd-row {
      background: #f0f0f0;
    }

    &:not(.is-first-row) {
      border-right: 1px solid var(--line-color-line-grey-02, #eee);
    }

    &.is-first-row {
      color: var(--main-color-ua-white, #fff);
      line-height: 20px;
      background: #000000;
    }
  }
}
</style>

<style lang="scss" layput="mobile" description="移动端样式">
.page-layout_mobile .ua-size-info {
  &__tlt {
    font-size: 16px;
  }
  &__item {
    margin-bottom: 20px;
  }

  &__meas-pic {
    width: 160px;
    height: auto;
  }
}

.page-layout_mobile .ua-size-table {
  &-cell {
    padding: 11px 0px;
    font-size: 12px;

    &.is-first-row {
      line-height: 18px;
    }
  }
}
</style>
